/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { useAtomValue } from 'jotai';
import { SanityImage } from '../../../../../../../../SanityImage';
import { pathnameUrlLanguageAtom } from '../../../../../../../../../history';
import { useSanityFeaturedHomeNews } from '../../../../../../../../../sanity';

const style: ouiStyle.InStyle = {
  position: 'absolute',
  display: ouiStyle.Constants.DisplayProp.flex,
  alignItems: ouiStyle.Constants.AlignItemsProp.center,
  justifyContent: ouiStyle.Constants.JustifyContentProp.center,
  cursor: 'pointer',
  top: 0,
  left: 0,
  right: 0,
  lines: 'full',
  paddingVertical: 'none',
};

const css = ouiStyle.mediaQuery(ouiStyle.makeCss(style));

export const HomeFeaturedNewsImage = () => {
  const {
    data,
  } = useSanityFeaturedHomeNews();
  const {
    image,
    slug,
  } = data ?? {};
  const locale = useAtomValue(pathnameUrlLanguageAtom);
  const history = ouiDom.A.useHistory();
  const onClick = React.useCallback(() => { history.push(`/${locale}/news/${slug}`); }, [slug, history, locale]);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      css={css}
      onClick={onClick}
    >
      <SanityImage
        image={image}
        maxPotentialWidth={640}
        defaultAspectRatio={1.7375886524822695}
        containerMarginVertical="none"
        objectFit="cover"
        lines="full"
      />
    </div>
  );
};
